var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-default bg-white py-5 px-4 shadow-primary rounded-10px w-352px flex flex-col space-y-1 border",class:{
    'border-danger-50': _vm.data.type === 'danger',
    'border-primary-300': _vm.data.type === 'success',
    'border-orange-300': _vm.data.type === 'warning',
  }},[(_vm._title)?[_c('span',{staticClass:"text-lg font-bold",class:{
        'text-danger-50': _vm.data.type === 'danger',
        'text-primary-300': _vm.data.type === 'success',
        'text-orange-300': _vm.data.type === 'warning',
      }},[_vm._v(" "+_vm._s(_vm._title)+" ")])]:_vm._e(),_c('span',{staticClass:"text-base"},[_vm._v(_vm._s(_vm.data.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }